import React from 'react';
import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material';

const STATUS_LABELS: Record<string, string> = {
  PROVISIONING: 'Provisioning',
  ACTIVE: 'Active',
  DEPRECATING: 'Deprecating',
};

const STATUS_COLOR: Record<string, ChipProps['color']> = {
  PROVISIONING: 'info',
  ACTIVE: 'success',
  DEPRECATING: 'warning',
};

interface ConfigurationStatusChipProps {
  status?: string;
  size?: 'small' | 'medium';
}

const ConfigurationStatusChip: React.FC<ConfigurationStatusChipProps> = ({ status, size = 'small' }) => {
  const key = status ?? '';
  return <Chip label={STATUS_LABELS[key] ?? key ?? 'Unknown'} color={STATUS_COLOR[key] ?? 'default'} size={size} />;
};

export default ConfigurationStatusChip;
